<template>
  <div class="cblog-news">
    <div class="cblog-news-image">
      <a :href="`/blog/${alias}`"><img :src="contentImageUrl"></a>
    </div>
    <div class="cblog-news-head">
      <a :href="`/blog/${alias}`">{{name}}</a>
    </div>
    <div class="cblog-news-content">
      <p>{{shortContent.substring(0, 200)+'...'}}</p>
    </div>
    <div class="cblog-readmore"><a :href="`/blog/${alias}`">Read More...</a></div>
  </div>
</template>

<script>
export default {
  name: 'BlogPage',
  props: {
    blog: {
      type: Object
    }
  },
  data () {
    return {
      id: 0,
      name: '',
      alias: '',
      shortContent: '',
      longContent: '',
      contentImageUrl: ''
    }
  },
  methods: {
    setData () {
      const { alias, name, id, contentType, shortContent, longContent, contentImageUrl } = JSON.parse(JSON.stringify(this.blog))
      this.id = id
      this.alias = alias
      this.name = name
      this.contentType = contentType
      this.shortContent = shortContent
      this.longContent = longContent
      this.contentImageUrl = contentImageUrl
    }
  },
  mounted () {
    this.setData()
  }
}
</script>

